import { render, staticRenderFns } from "./PostNav.vue?vue&type=template&id=23a7d030&scoped=true"
import script from "./PostNav.vue?vue&type=script&lang=js"
export * from "./PostNav.vue?vue&type=script&lang=js"
import style0 from "./PostNav.vue?vue&type=style&index=0&id=23a7d030&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a7d030",
  null
  
)

export default component.exports